// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let WizardFormUtils = require("../wizard/WizardFormUtils.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql = require("../../../__generated__/DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql.bs.js");

let convertFragment = DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql.node, convertFragment, fRef);
}

let ProjectFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function DevelopmentProjectSearchResultTitleAndLocation(props) {
  let project = RescriptRelay_Fragment.useFragment(DevelopmentProjectSearchResultTitleAndLocation_developmentProject_graphql.node, convertFragment, props.project);
  let title = Stdlib_Option.getOr(WizardFormUtils.noneIfEmpty(project.name), "Untitled development");
  let match = project.location;
  let tmp;
  if (match !== undefined) {
    let exit = 0;
    switch (match.__typename) {
      case "PropertyLocationWithHiddenAddress" :
      case "PropertyLocationWithVisibleAddress" :
        exit = 1;
        break;
      case "__unselected" :
        tmp = UnselectedUnionMemberError.raise(match._0);
        break;
    }
    if (exit === 1) {
      tmp = JsxRuntime.jsx("div", {
        children: match.locationDisplay,
        className: "text-zinc-600 text-lg font-normal"
      });
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(ViewStack.make, {
    space: "xs",
    children: [
      JsxRuntime.jsx("h3", {
        children: title,
        className: "text-zinc-700 text-lg font-medium leading-tight"
      }),
      tmp
    ]
  });
}

let make = DevelopmentProjectSearchResultTitleAndLocation;

exports.ProjectFragment = ProjectFragment;
exports.make = make;
/* ViewStack Not a pure module */
